import { memo, useMemo, useState } from 'react';
import { Tabs, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { EditProfileMediaTabItem } from './EditProfileMedia.styles';
import { AgencyPermissionEnums } from 'shared/enums/AgencyPermissionEnums';
import { EditProfileMediaProvider } from '../../context/EditProfileMediaProvider';
import EditProfileMediaDocuments from '../EditProfileMediaDocuments/EditProfileMediaDocuments';

type CurrentTabProps = 'Media/Documents' | 'Resume' | 'Composite Card';

type TabsProps = {
  name: string;
  value: CurrentTabProps;
};

type EditProfileMediaProps = {
  handleAction: (agencyPermission: AgencyPermissionEnums, callback: VoidFunction) => void;
};

const EditProfileMedia = ({ handleAction }: EditProfileMediaProps) => {
  const [currentTab, setCurrentTab] = useState<CurrentTabProps>('Media/Documents');
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const handleOnChange = (value: CurrentTabProps) => {
    setCurrentTab(value);
  };

  const tabs: TabsProps[] = [
    {
      name: 'Media/Documents',
      value: 'Media/Documents',
    },
    {
      name: 'Resume',
      value: 'Resume',
    },
    {
      name: 'Composite Card',
      value: 'Composite Card',
    },
  ];

  const renderTabContent = useMemo(() => {
    switch (currentTab) {
      case 'Media/Documents':
        return <EditProfileMediaDocuments />;
      case 'Resume':
        return <p>Resume</p>;
      case 'Composite Card':
        return <p>Composite Card</p>;
      default:
        return null; // Handle unknown cases
    }
  }, [currentTab]);

  return (
    <EditProfileMediaProvider handleAction={handleAction}>
      <div style={{ minWidth: 0 }}>
        <Tabs
          value={currentTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, newValue: CurrentTabProps) => handleOnChange(newValue)}
          variant={matches ? 'standard' : 'fullWidth'}
          style={{ marginTop: matches ? -10 : undefined }}
        >
          {tabs.map((tab) => (
            <EditProfileMediaTabItem
              style={{ textTransform: 'none', padding: 0 }}
              label={tab.name}
              value={tab.value}
              key={tab.value}
            />
          ))}
        </Tabs>
        {renderTabContent}
      </div>
    </EditProfileMediaProvider>
  );
};

export default memo(EditProfileMedia);
